import script from "./LeftRightPie.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftRightPie.vue?vue&type=script&setup=true&lang=js"

export default script